import React, { useEffect, useState } from "react";
import { BadgeCheck, CircleSlash, CircleHelp, Loader2 } from "lucide-react";

// Esito della verifica notturna. Il server ricompila da solo, ogni notte, l'APK che
// pubblica e lo confronta voce per voce con quello che scaricate. Qui c'è il risultato
// dell'ultimo giro, con la data: se la data è vecchia, la riga lo dice invece di tacere.
const fmt = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export default function VerifyStatus() {
  const [s, setS] = useState(null);

  useEffect(() => {
    let alive = true;
    fetch("/downloads/verify-status.json", { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((j) => alive && setS(j))
      .catch(() => alive && setS({ state: "unknown" }));
    return () => { alive = false; };
  }, []);

  if (!s) {
    return (
      <span data-testid="verify-loading" className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-[#666]">
        <Loader2 className="h-3 w-3 animate-spin" /> verifica
      </span>
    );
  }

  const stale = s.checked_at ? (Date.now() - new Date(s.checked_at).getTime()) > 1000 * 60 * 60 * 40 : true;
  const map = {
    verified: { Icon: BadgeCheck, color: "#50C878", label: "Verificata · VERIFIED" },
    failed: { Icon: CircleSlash, color: "#f5f5f5", label: "Verifica · FAILED" },
    error: { Icon: CircleHelp, color: "#888", label: "Verifica · non conclusa" },
    unknown: { Icon: CircleHelp, color: "#888", label: "Verifica · nessun dato" },
  };
  const { Icon, color, label } = map[s.state] || map.unknown;

  return (
    <div data-testid="verify-badge" className="border p-3" style={{ borderColor: `${color}55`, background: `${color}0f` }}>
      <div className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em]" style={{ color }}>
        <Icon className="h-4 w-4" /> {label}
      </div>
      <p className="mt-2 font-mono text-[11px] leading-relaxed text-[#8a8a8a]" data-testid="verify-detail">
        {s.state === "verified" && (
          <>Stanotte il server ha ricompilato la <b className="text-[#d4d4d4]">v{s.version}</b> in un
            container pulito: <b className="text-[#d4d4d4]">{s.entries} voci su {s.entries} identiche</b>{" "}
            all'APK pubblicato. Ultimo controllo: <b className="text-[#d4d4d4]">{fmt(s.checked_at)}</b>.</>
        )}
        {s.state === "failed" && (
          <>L'APK ricompilato stanotte <b className="text-white">non combacia</b>
            {s.differing ? <> — {s.differing} voci diverse su {s.entries}</> : null}. Non lo nascondiamo:
            leggete il Transparency Report prima di installare. Controllo: {fmt(s.checked_at)}.</>
        )}
        {(s.state === "error" || s.state === "unknown") && (
          <>L'ultimo giro non è arrivato al confronto{s.note ? <> ({s.note})</> : null}. «Non lo so» è una
            risposta migliore di un sì automatico. {s.checked_at ? <>Tentativo: {fmt(s.checked_at)}.</> : null}</>
        )}
        {stale && s.state === "verified" && (
          <> <b className="text-white">Attenzione: questo esito ha più di 40 ore.</b> Il giro notturno
            potrebbe non essere andato a buon fine.</>
        )}
      </p>
      <a href="/downloads/verify-status.json" data-testid="verify-raw"
         className="mt-2 inline-block font-mono text-[10px] uppercase tracking-[0.25em] text-[#666] underline hover:text-[#a3a3a3]">
        esito grezzo
      </a>
    </div>
  );
}
